import { configureStore } from '@reduxjs/toolkit';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import dashboard from './modules/dashboard/reducers/index';
import authState from './modules/auth/reducers/index';
import commonState from './common/reducers/index';
import paymentState from './modules/payment/reducers/index';
import statsState from './modules/inventory/stats/reducers/index';
import supplierInvoiceState from './modules/inventory/invoices/reducers/index';
import supplierReturnState from './modules/inventory/supplierReturn/reducers/index';
import productsState from './modules/inventory/products/reducers/index';
import categoriesState from './modules/inventory/categories/reducers/index';
import suppliersState from './modules/inventory/suppliers/reducers/index';
import stocksState from './modules/inventory/stocks/reducers/index';
import shipmentsState from './modules/delivery/shipments/reducers/index';
import customersState from './modules/crm/customers/reducers/index';
import trendingProductsState from './modules/reports/products/reducers/index';
import customerReportsState from './modules/reports/customers/reducers/index';
import billHistoryState from './modules/reports/billHistory/reducers/index';
import categorySalesState from './modules/reports/category/reducers/index';
import cashBalanceState from './modules/reports/cashBalance/reducers/index';
import receiptSettingsState from './modules/settings/receipt/reducers/index';
import warrantySettingsState from './modules/settings/warranty/reducers/index';
import productSettingsState from './modules/settings/product/reducers/index';
import layoutSettingsState from './modules/settings/layout/reducers/index';
import usersState from './modules/iam/users/reducers/index';
import paymentMethodsState from './modules/settings/payments/reducers/index';
import orderSettingsState from './modules/settings/order/reducers/index';
import modifierSettingsState from './modules/settings/modifiers/reducers/index';
import businessDaySettingsState from './modules/settings/businessDay/reducers/index';
import theme from './common/reducers/theme';

const intialState = {};
const middleWare = [thunk];
export const store = configureStore({
  reducer: {
    theme,
    dashboard,
    authState,
    commonState,
    paymentState,
    statsState,
    supplierInvoiceState,
    supplierReturnState,
    productsState,
    categoriesState,
    suppliersState,
    stocksState,
    shipmentsState,
    customersState,
    trendingProductsState,
    customerReportsState,
    billHistoryState,
    categorySalesState,
    cashBalanceState,
    receiptSettingsState,
    warrantySettingsState,
    productSettingsState,
    layoutSettingsState,
    usersState,
    paymentMethodsState,
    orderSettingsState,
    modifierSettingsState,
    businessDaySettingsState,
  },
});
export default store;
